export default "__VITE_ASSET__CmWqKCz9__"